import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import { useHistory } from "react-router-dom";
import { AuthXService } from "@brg/auth";
import { useMemo } from "react";

const ONLINES_DESIGN_URL = process.env.REACT_APP_URL_HSEDESIGN_COM || 'https://onlines.design';

export const useOnlinesDesignContexts = () => {
    const { isOnlinesDesign } = useAppTester();
    const suffix = AuthXService.isAuthenticated() ? '?shouldLogin=true&saveLoginUrl=true' : '';
    const history = useHistory();

    const links = useMemo(() => ([
        {
            id: 'onlines_design',
            active: isOnlinesDesign,
            content: 'onlines.design',
            menuTitleSuffix: '',
            linkTo: ONLINES_DESIGN_URL + suffix,
            action: () => {
                if (isOnlinesDesign) {
                    history.push('/');
                    return;
                }
                window.open(ONLINES_DESIGN_URL + suffix, '_self');
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            externalLink: true,
        },
    ]), [history, suffix, isOnlinesDesign]);

    return {
        links,
        modalSettings: {
            titleColor: '',
            title: '',
        },
    };
};
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import { useHistory } from "react-router-dom";
import { AuthXService } from "@brg/auth";
import { useMemo } from "react";

const ONLINES_DESIGN_URL = process.env.REACT_APP_URL_HSEDESIGN_COM || 'https://onlines.design';

export const useOnlinesDesignContexts = () => {
    const { isOnlinesDesign } = useAppTester();
    const suffix = AuthXService.isAuthenticated() ? '?shouldLogin=true&saveLoginUrl=true' : '';
    const history = useHistory();

    const links = useMemo(() => ([
        {
            id: 'onlines_design',
            active: isOnlinesDesign,
            content: 'onlines.design',
            menuTitleSuffix: '',
            linkTo: ONLINES_DESIGN_URL + suffix,
            action: () => {
                if (isOnlinesDesign) {
                    history.push('/');
                    return;
                }
                window.open(ONLINES_DESIGN_URL + suffix, '_self');
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            externalLink: true,
        },
    ]), [history, suffix, isOnlinesDesign]);

    return {
        links,
        modalSettings: {
            titleColor: '',
            title: '',
        },
    };
};
